import { Slot } from '@radix-ui/react-slot';
import { type ComponentPropsWithRef, type ReactNode } from 'react';

import s from './VisuallyHidden.module.css';

interface VisuallyHiddenProps extends ComponentPropsWithRef<'span'> {
  asChild?: boolean;
  children: ReactNode;
}

export const VisuallyHidden = (props: VisuallyHiddenProps) => {
  const { asChild = false, children, ...attrs } = props;

  if (!children) {
    return null;
  }

  const Component = asChild ? Slot : 'span';

  return (
    <Component data-vh={true} className={s.visuallyHidden} {...attrs}>
      {children}
    </Component>
  );
};
